import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getCompanyAccountType } from "../../../../reducers/companySelector";
import Loading from "../../../common/loading";
import { RestrictedCompanyAccountType } from "../../../../utils/constants";
import ProjectList from "./projectListv2";
import EducationList from "./educationListv2";
import CertificateList from "./certificateListv2";
import PersonalInterestList from "./personalInterestListv2";
import QuestionnaireAnswers from "./questionnaireAnswers";
import { useTranslation } from "react-i18next";
import { Modal, Tabs, Button, Divider } from "antd";
import {
	BranchNameIcon,
	CertificateIcon,
	CollegeIcon,
	ProjectIcon,
	TextMessageIcon,
} from "../../../common/icons";

import "./studentDetailsDialog_v2.css";

const { TabPane } = Tabs;

const StudentDetailsDialog = ({
	onCloseHandler,
	companyAccountType,
	studentDetails,
	isLoading,
}) => {
	const { t } = useTranslation();
	const [showMoreDetails, setShowMoreDetails] = useState(false);
	const [activeEducationNav, setActiveEducationNav] = useState(true);
	const [activeProjectNav, setActiveProjectNav] = useState(false);
	const [activeCertificateNav, setActiveCertificateNav] = useState(false);
	const [activeExtracurricularNav, setActiveExtracurricularNav] =
		useState(false);

	const onClickShowMoreDetail = () => {
		setShowMoreDetails(!showMoreDetails);
	};

	const isRestrictedAccountType =
		RestrictedCompanyAccountType.includes(companyAccountType);

	const onClickEducationNav = () => {
		setActiveEducationNav(true);
		setActiveProjectNav(false);
		setActiveCertificateNav(false);
		setActiveExtracurricularNav(false);
	};
	const onClickProjectNav = () => {
		setActiveEducationNav(false);
		setActiveProjectNav(true);
		setActiveCertificateNav(false);
		setActiveExtracurricularNav(false);
	};
	const onClickCertificateNav = () => {
		setActiveEducationNav(false);
		setActiveProjectNav(false);
		setActiveCertificateNav(true);
		setActiveExtracurricularNav(false);
	};
	const onClickExtracurricularNav = () => {
		setActiveEducationNav(false);
		setActiveProjectNav(false);
		setActiveCertificateNav(false);
		setActiveExtracurricularNav(true);
	};

	return (
		<>
			<Modal
				title={`${
					isRestrictedAccountType
						? "Student profile details"
						: studentDetails.name
				}`}
				centered
				visible={true}
				onOk={onCloseHandler}
				onCancel={onCloseHandler}
				width={1060}
				footer={null}
			>
				<div className="studentDetails_modal_body_container">
					{isLoading && <Loading />}
					{!isLoading && studentDetails && studentDetails.id && (
						<>
							<div className="studentDetails_modal_body_adminComment_container">
								<div className="studentDetails_modal_body_container_adminComment_title">
									<TextMessageIcon width={18} height={18} />
									<span className="text">
										{t("studentDetailsDialogue_adminComment_header")}
									</span>
								</div>
								<div className="studentDetails_modal_body_container_adminComment_description">
									{studentDetails.galkRecruitAdminComment ||
										`No Comments Provided`}
								</div>
							</div>
							<div>
								<Tabs size="small" defaultActiveKey="1">
									<TabPane tab="Profile" key="1">
										<div className="studentDetails_modal_body_bio_container">
											<div className="studentDetails_modal_body_bio_top_container">
												<div className="studentDetails_modal_body_bio_profileImage">
													<img src={studentDetails.img} alt="candidateAvatar" />
												</div>
												<div className="studentDetails_modal_body_bio_profileInformation">
													<div className="studentDetails_modal_body_bio_banner">
														<div className="b1">
															<span>
																{t(
																	"studentDetailsDialogue_body_tabProfile_banner_cumulativeScore"
																)}
																:{" "}
																{studentDetails.galkRecruitCumulativeScore ||
																	"~"}
															</span>
														</div>
														<div className="b2">
															<span>
																{t(
																	"studentDetailsDialogue_body_tabProfile_banner_interviewPoints"
																)}
																: {studentDetails.interviewPoints || "~"}
															</span>
														</div>
														<div className="b3">
															<span>{studentDetails.gender || "~"}</span>
														</div>
														<div className="b4">
															<span>
																{studentDetails.yearOfRegistration || "~"}{" "}
																Resister
															</span>
														</div>
													</div>
													<div className="name">{studentDetails.name}</div>
													<div className="college_container">
														<CollegeIcon width={16} height={16} />
														<span>{studentDetails.collegeName}</span>
													</div>
													<div className="branch_container">
														<BranchNameIcon width={16} height={16} />
														<span>{studentDetails.branchName}</span>
													</div>
													<div className="certificate_container">
														<div>
															<CertificateIcon width={16} height={16} />
															<span className="badge">
																{" "}
																{studentDetails.certificate
																	? studentDetails.certificate.length
																	: 0}
															</span>
															<span>
																{t(
																	"studentDetailsDialogue_body_tabProfile_certificateTag"
																)}
															</span>
														</div>

														<div>
															<ProjectIcon width={16} height={16} />
															<span className="badge">
																{" "}
																{studentDetails.project
																	? studentDetails.project.length
																	: 0}
															</span>
															<span>
																{t(
																	"studentDetailsDialogue_body_tabProfile_projectTag"
																)}
															</span>
														</div>
													</div>
													<div className="otherInfo_contaner">
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_yearOfAdmission_header"
																)}
															</div>
															<div className="body">
																{studentDetails.yearOfAdmission || "-n/a-"}
															</div>
														</div>
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_codingScore_header"
																)}
															</div>

															<div className="body">
																<>
																	<span>
																		{studentDetails.codingScore || "-n/a-"}
																	</span>
																	{studentDetails.codingTestDetail && (
																		<a
																			href={studentDetails.codingTestDetail}
																			target="_blank"
																		>
																			see details
																		</a>
																	)}
																</>
															</div>
														</div>
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_minorDegree_header"
																)}
															</div>
															<div className="body">
																{studentDetails.minorDegree || "-n/a-"}
															</div>
														</div>
													</div>
												</div>
											</div>
											{showMoreDetails && (
												<div className="studentDetails_modal_body_bio_moreDetails_container">
													<div className="heading">
														{t(
															"studentDetailsDialogue_body_tabProfile_sectionDetails_header"
														)}
													</div>
													<div className="row_container">
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_sectionDetails_dob_header"
																)}
															</div>
															<div className="body">
																{studentDetails.dob || "-n/a-"}
															</div>
														</div>
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_sectionDetails_placeOfBirth_header"
																)}
															</div>
															<div className="body">
																{studentDetails.placeOfBirth || "-n/a-"}
															</div>
														</div>
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_sectionDetails_religion_header"
																)}
															</div>
															<div className="body">
																{studentDetails.religion || "-n/a-"}
															</div>
														</div>
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_sectionDetails_languageSpeak_header"
																)}
															</div>
															<div className="body">
																{studentDetails.spokenLanguages
																	? studentDetails.spokenLanguages.join(", ")
																	: "-n/a-"}
															</div>
														</div>
													</div>
													<div className="row_container">
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_sectionDetails_foodPrefer_header"
																)}
															</div>
															<div className="body">
																{studentDetails.foodPrefer
																	? studentDetails.foodPrefer.join(", ")
																	: "-n/a-"}
															</div>
														</div>
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_sectionDetails_foodAvoid_header"
																)}
															</div>
															<div className="body">
																{studentDetails.foodAvoid
																	? studentDetails.foodAvoid.join(", ")
																	: "-n/a-"}
															</div>
														</div>
													</div>
													<div className="row_container">
														{/* <div className="">
															<div className="header">Registered email</div>
															<div className="body">
																{studentDetails.email || "-n/a-"}
															</div>
														</div> */}
														{/* <div className="">
															<div className="header">Secondary email</div>
															<div className="body">
																{studentDetails.personalEmail || "-n/a-"}
															</div>
														</div> */}
														{/* <div className="">
															<div className="header">Whatsapp number</div>
															<div className="body">
																{studentDetails.mobileNumber || "-n/a-"}
															</div>
														</div> */}
														{/* <div className="">
															<div className="header">
																Do you have passport?
															</div>
															<div className="body">
																{studentDetails.passportNumber || "-n/a-"}
															</div>
														</div> */}
														<div className="">
															<div className="header">
																{t(
																	"studentDetailsDialogue_body_tabProfile_sectionDetails_japaneseProfeiciency_header"
																)}
															</div>
															<div className="body">
																{studentDetails.japaneseProficiency || "-n/a-"}
															</div>
														</div>
													</div>
													<div className="row_container">
														<div className="">
															<div className="header">GitHub link</div>
															<div className="body">
																{studentDetails.githubProfileLink || "-n/a-"}
															</div>
														</div>
														{/* <div className="">
															<div className="header">LinkedIn link</div>
															<div className="body">
																{studentDetails.linkedinURL || "-n/a-"}
															</div>
														</div> */}
													</div>
												</div>
											)}
											<div className="studentDetails_modal_body_bio_moreDetails_footer">
												<Button type="link" onClick={onClickShowMoreDetail}>
													{showMoreDetails
														? t(
																"studentDetailsDialogue_body_tabProfile_seeMoreDetails_close"
														  )
														: t(
																"studentDetailsDialogue_body_tabProfile_seeMoreDetails"
														  )}
												</Button>
											</div>
										</div>
										<Divider />
										<div className="studentDetails_modal_body_skill_container">
											<div className="heading">
												{t(
													"studentDetailsDialogue_body_tabProfile_sectionSkill_header"
												)}
											</div>
											<div className="row_container">
												<div className="">
													<div className="header">
														{t(
															"studentDetailsDialogue_body_tabProfile_sectionSkill_experienceBased_header"
														)}
													</div>
													<div className="body_withTag_container">
														{studentDetails.skills
															? studentDetails.skills.map((x, i) => (
																	<div key={i}>{x}</div>
															  ))
															: "-n/a-"}
													</div>
												</div>
											</div>
											<div className="row_container">
												<div className="">
													<div className="header">
														{t(
															"studentDetailsDialogue_body_tabProfile_sectionSkill_knowledgeBased_header"
														)}
													</div>
													<div className="body_withTag_container">
														{studentDetails.secondarySkills
															? studentDetails.secondarySkills.map((x, i) => (
																	<div key={i}>{x}</div>
															  ))
															: "-n/a-"}
													</div>
												</div>
											</div>
										</div>
										{studentDetails.video && (
											<div className="studentDetails_modal_body_video_container">
												<div className="heading">
													{t(
														"studentDetailsDialogue_body_tabProfile_sectionIntroVideo_header"
													)}
												</div>
												<video
													loop
													preload="none"
													// autoPlay
													controls
													controlsList="nodownload"
													poster={studentDetails.img}
													onContextMenu={(e) => {
														e.preventDefault();
														return false;
													}}
												>
													<source
														src={studentDetails.video}
														type="video/mp4"
													></source>
													&gt; Your browser does not support HTML5 video.
												</video>
											</div>
										)}
										<div className="studentDetails_modal_body_allInfo_container">
											<div className="studentDetails_modal_body_allInfo_headerButtons_container">
												<div
													className={`headerButton${
														activeEducationNav ? "_active" : ""
													}`}
													onClick={onClickEducationNav}
												>
													{t(
														"studentDetailsDialogue_body_tabProfile_tabEducation_header"
													)}
												</div>
												<div
													className={`headerButton${
														activeProjectNav ? "_active" : ""
													}`}
													onClick={onClickProjectNav}
												>
													{t(
														"studentDetailsDialogue_body_tabProfile_tabProject_header"
													)}
												</div>
												<div
													className={`headerButton${
														activeCertificateNav ? "_active" : ""
													}`}
													onClick={onClickCertificateNav}
												>
													{t(
														"studentDetailsDialogue_body_tabProfile_tabCertificate_header"
													)}
												</div>
												<div
													className={`headerButton${
														activeExtracurricularNav ? "_active" : ""
													}`}
													onClick={onClickExtracurricularNav}
												>
													{t(
														"studentDetailsDialogue_body_tabProfile_tabExtraCurricular_header"
													)}
												</div>
											</div>
											<div className="studentDetails_modal_body_allInfo_body_container">
												{activeEducationNav && (
													<EducationList list={studentDetails.education} />
												)}
												{activeProjectNav && (
													<ProjectList list={studentDetails.projects || []} />
												)}
												{activeCertificateNav && (
													<CertificateList
														list={studentDetails.certificates || []}
													/>
												)}
												{activeExtracurricularNav && (
													<PersonalInterestList
														list={studentDetails.personalInterest}
													/>
												)}
											</div>
										</div>
									</TabPane>
									<TabPane tab="Questionnaire" key="2">
										<QuestionnaireAnswers
											questionnaireAnswers={
												studentDetails.galkRecruitQuestionnaireAnswers
											}
										/>
									</TabPane>
								</Tabs>
							</div>
						</>
					)}
				</div>
			</Modal>
		</>
	);
};

const mapStateToProps = (state) => ({
	companyAccountType: getCompanyAccountType(state),
});

export default connect(mapStateToProps, {})(StudentDetailsDialog);
